// @flow

export const DOCUMENTS_FORM_CREATE = 'DOCUMENTS_FORM_CREATE';
export const NEW_PATIENT_DOCUMENTS_FORM_CREATE = 'NEW_PATIENT_DOCUMENTS_FORM_CREATE';
export const DOCUMENTS_FORM_CREATED = 'DOCUMENTS_FORM_CREATED';
export const DOCUMENTS_FORM_CREATE_ERROR = 'DOCUMENTS_FORM_CREATE_ERROR';
export const DOCUMENTS_BULK_UPLOAD = 'DOCUMENTS_BULK_UPLOAD';

export const DOCUMENTS_FORM_DELETE = 'DOCUMENTS_FORM_DELETE';
export const DOCUMENTS_FORM_DELETED = 'DOCUMENTS_FORM_DELETED';
export const DOCUMENTS_FORM_DELETE_ERROR = 'DOCUMENTS_FORM_DELETE_ERROR';

export const DOCUMENTS_FORM_UPDATE = 'DOCUMENTS_FORM_UPDATE';
export const DOCUMENTS_FORM_UPDATED = 'DOCUMENTS_FORM_UPDATED';
export const DOCUMENTS_FORM_UPDATE_ERROR = 'DOCUMENTS_FORM_UPDATE_ERROR';
